import React from 'react';
import CabinetShell from '../../components/UI/CabinetShell/cabinetShell';
import SettingsNav from '../../components/UI/SettingsNav/settingsNav';
import { useAuth } from '../../context/AuthContext';
import './settings.css';

// WEB-2: профиль владельца (read-only). Данные — из AuthContext (/website/me).
const ROLE_LABELS = { admin: 'Администратор', employee: 'Сотрудник' };

const Profile = () => {
  const [activeLink, setActiveLink] = React.useState(null);
  const { username, role, loaded } = useAuth();

  React.useEffect(() => {
    setActiveLink(
      `${window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)}`
    );
  });

  return (
    <CabinetShell title="Профиль" floor={false}>
      <SettingsNav activeLink={activeLink} setActiveLink={setActiveLink} />

      <div className="settingsContent">
        <div className="profileContent">
          <p className="profileTitle">Профиль владельца</p>
          {!loaded ? (
            <p>Загрузка…</p>
          ) : (
            <>
              <p>
                Имя пользователя:{' '}
                <b data-testid="profile-username">{username || '—'}</b>
              </p>
              <p>
                Роль: <b data-testid="profile-role">{ROLE_LABELS[role] || role || '—'}</b>
              </p>
            </>
          )}
        </div>
      </div>
    </CabinetShell>
  );
};

export default Profile;
